var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "marker arrow-bottom u-row u-stretch",
      on: {
        wheel: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "container u-col",
          class: { active: _vm.data },
          style: { maxHeight: _vm.maxHeight + "px" }
        },
        [
          _c("ui-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.request,
                expression: "request"
              }
            ],
            staticClass: "spinner u-center"
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.error,
                  expression: "error"
                }
              ],
              staticClass: "error u-center cl-gray t16"
            },
            [_vm._v("\n            Could not load data\n        ")]
          ),
          _vm._v(" "),
          _c("ui-image", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.src,
                expression: "src"
              }
            ],
            ref: "image",
            staticClass: "image",
            attrs: { src: _vm.src }
          }),
          _vm._v(" "),
          _vm.data
            ? _c(
                "div",
                { staticClass: "content u-flex" },
                [
                  _c("a", { staticClass: "t14 w7 cl-blue" }, [
                    _vm._v(_vm._s(_vm.data.name))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "t11" }, [
                    _vm._v(_vm._s(_vm.data.address))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "t11 date" }, [
                    _vm._v(_vm._s(_vm._f("date")(_vm.data.builtAt)) + "築")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.data.deals, function(deal) {
                    return _c("item-deal", {
                      key: deal.id,
                      staticClass: "deal t11",
                      attrs: { deal: deal },
                      on: {
                        select: function($event) {
                          return _vm.select({ deal: deal, building: _vm.data })
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }